import type { FilterOptions } from '../mapFilters';

const addTrailingSlash = (str: string) =>
  !str.length || str.endsWith('/') ? str : `${str}/`;

const updateTwitterDomain = (url: string) =>
  url.replace('twitter.com', 'x.com');

const normalizeURL = (url: string) => {
  try {
    const normalizedUrl = new URL(url);
    const { origin, pathname, search } = normalizedUrl;

    const normalizedPath = addTrailingSlash(pathname);

    return updateTwitterDomain(origin) + normalizedPath + search;
  } catch (e) {
    return url;
  }
};

const optionHasEqualURL = (option: string[], url: string) =>
  option.some((optionURL) => normalizeURL(optionURL).includes(url));

export const filterByURL = (
  url: string,
  { exclude, include }: FilterOptions
) => {
  const flags = {
    shouldInclude: false,
    shouldExclude: false
  };

  const normalizedURL = normalizeURL(url);

  // Если есть такой url, то не пускаем
  if (exclude.length) {
    flags.shouldExclude = optionHasEqualURL(exclude, normalizedURL);
  }

  // Пускаем, если есть такой url в include
  if (include.length) {
    flags.shouldInclude = optionHasEqualURL(include, normalizedURL);
  }

  return flags;
};
